import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h4>K9HKR Studios</h4>
                        <p>
                            Innovative web development solutions specializing in modern full-stack
                            applications, APIs, and digital transformation services.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Services</h4>
                        <p>Full-Stack Development</p>
                        <p>API Development</p>
                        <p>System Architecture</p>
                        <p>Technical Consulting</p>
                    </div>

                    <div className="footer-section">
                        <h4>Technologies</h4>
                        <p>React & TypeScript</p>
                        <p>Spring Boot & Java</p>
                        <p>MySQL & Databases</p>
                        <p>Docker & Cloud</p>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} K9HKR Studios. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
